import Swiper from "swiper";
import { notifyErrorWithText } from "../../modules/notifications/index.js";
import { Navigation, Pagination } from "swiper/modules";


function initCaseSlider() {
    const slider = new Swiper("#horeca-slider", {
        modules: [Navigation],
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: {
            prevEl: "#horeca-slider + .slider-navigation > .slider-navigation-prev",
            nextEl: "#horeca-slider + .slider-navigation > .slider-navigation-next",
        },
    });
}

function initProdsSlider() {
    const slider = new Swiper("#horeca-prods__slider", {
        modules: [Navigation],
        slidesPerView: "auto",
        spaceBetween: 16,
        navigation: {
            prevEl: "#horeca-prods__slider + .slider-navigation > .slider-navigation-prev",
            nextEl: "#horeca-prods__slider + .slider-navigation > .slider-navigation-next",
        },
        breakpoints: {
            576: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: 4,
            },
        },
    });
}

function initToFormBtn() {
    const form = document.querySelector(".horeca-order__form");
    const bannerToFormLink = document.querySelector(".horeca-order__to-form-banner");
    const btn = document.querySelector(".horeca-order__to-form");
    const targetEl = document.querySelector(".horeca-prods__title");

    if (!form || !btn || !targetEl) return;

    const spacing = 20;
    const headerHeight = 150;

    const updateButtonPosition = () => {
        const isDesktop = window.innerWidth >= 992;

        if (!isDesktop) {
            btn.removeAttribute("style");
            btn.classList.remove("fixed");
            return;
        }

        const targetRect = targetEl.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

        const triggerPoint = targetRect.top + scrollTop - headerHeight;
        const btnWidth = btn.offsetWidth;

        // Координаты targetEl
        const top = targetRect.top + scrollTop;
        let left = targetRect.right + spacing + scrollLeft;
        const maxLeft = window.innerWidth - btnWidth - spacing;
        left = Math.min(left, maxLeft);

        if (window.scrollY < triggerPoint) {
            // До достижения хедера — позиция относительно targetEl
            btn.style.position = "absolute";
            btn.style.left = `${left}px`;
            btn.style.top = `${top}px`;
            btn.classList.remove("fixed");
        } else {
            // После достижения хедера — фиксируем кнопку
            btn.style.position = "fixed";
            btn.style.left = `${left}px`;
            btn.style.top = `${headerHeight}px`;
            btn.classList.add("fixed");
        }
    };

    updateButtonPosition();
    window.addEventListener("scroll", updateButtonPosition);
    window.addEventListener("resize", updateButtonPosition);

    // Скрытие кнопки при видимости формы или баннер-ссылки
    const observer = new IntersectionObserver(
        (entries) => {
            let shouldHide = false;

            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    shouldHide = true;
                }
            });

            if (shouldHide) {
                btn.classList.add("hidden");
            } else {
                btn.classList.remove("hidden");
            }
        },
        {
            root: null,
            threshold: 0.1,
        }
    );

    if (form) {
        observer.observe(form);
    }
    if (bannerToFormLink) {
        observer.observe(bannerToFormLink);
    }
}

function initHorecaPageModules() {
    const horecaCaseSlider = document.getElementById("horeca-slider");

    const horecaProdsSlider = document.getElementById("horeca-prods__slider");

    if (horecaCaseSlider) {
        initCaseSlider();
    }

    if (horecaProdsSlider) {
        initProdsSlider();
    }

    initToFormBtn();
}

window.onload = () => {
    initHorecaPageModules();
};